<template>
    <div class="feedback-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="feedback-content mask-content">
            <span class="close-icon" @click="isShow = false"></span>
            <div class="mask-title">意见反馈</div>
            <div class="item-wrap">
                <div class="item">
                    <div class="title">您遇到的问题</div>
                    <div class="question-type">
                        <template v-if="questions">
                            <span class="type-wrap" v-for="(item, index) in questions" @click="choosed(item)" :key="index">
                                <i class="i1" :class="{ checked: item.value == checked }"></i>
                                <i v-if="item.value == checked" class="i1_checked"></i>
                                <i class="i2" :class="{ checked: item.value == checked }">{{ item.name }}</i>
                            </span>
                        </template>
                    </div>
                </div>
                <div class="item upload-item">
                    <div class="title textarea-title">问题描述</div>
                    <div class="upload-wrap">
                        <div class="question-type">
                            <textarea v-model="content" placeholder="请输入内容，最多100个字符" maxlength="100"></textarea>
                            <span class="left-txt">
                                <i class="i1">{{ content.length }}</i>
                                <i class="i2">/100</i>
                            </span>
                        </div>
                        <div class="upload-section hide-scroll">
                            <label class="img-item upload-btn">
                                <input type="file" hidden @change="changeFile" accept="image/png, image/jpeg, image/gif" />
                            </label>
                            <div class="img-item" v-for="(item, index) in pic" :key="index">
                                <img class="img" :src="PREVIEW_DOMAIN + item.img" />
                                <span class="icon" @click="delImg(item)"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="title input-title">联系方式</div>
                    <div class="question-type">
                        <input oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" v-model="contact" type="text" placeholder="请输入联系方式，QQ号码或者手机号" maxlength="11" />
                    </div>
                </div>
            </div>
            <div class="submit-btn" @click="submit" :class="{ disabled: !canSubmit ? true : false }">
                提交
            </div>
        </div>
    </div>
</template>
<script>
import { feedback } from '@/http/api/common'
import { upload } from '@/http/api/upload'
import { getCookieToken } from '@/utils/auth.js'
import config from '@/http/config'

export default {
    name: 'Feedback',
    data() {
        return {
            PREVIEW_DOMAIN: config.PREVIEW_DOMAIN,
            isShow: false,
            questions: [
                { value: 3, name: '使用问题' },
                { value: 4, name: '账号问题' },
                { value: 5, name: '会员问题' },
                { value: 6, name: '操作问题' }
            ],
            request: false,
            pic: [],
            content: '', // 反馈内容
            contact: '', // 联系方式
            checked: ''
        }
    },
    computed: {
        canSubmit: function() {
            return String(this.checked).length && this.pic.length && this.content.length && this.contact.length
        }
    },
    watch: {
        isShow: function(value) {
            if (!value) {
                this.checked = ''
                this.pic = []
                this.content = ''
                this.contact = ''
                this.request = false
            } else {
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('feedback-page')
                })
            }
        }
    },
    methods: {
        show() {
            this.isShow = true
        },
        choosed(item) {
            if (item.value == this.checked) {
                this.checked = ''
            } else {
                this.checked = item.value
            }
        },
        changeFile(event) {
            const file = event.target.files[0]
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
            const isLt2M = file.size / 1024 / 1024 < 2

            if (!isJPG) {
                return this.$Toast.show('上传图片只能是 JPG、PNG、GIF 格式!')
            }

            if (!isLt2M) {
                return this.$Toast.show('上传图片大小不能超过2MB')
            }

            if (this.pic.length >= 4) {
                return this.$Toast.show('最多上传4张图片')
            }

            event.target.value = ''

            upload(file)
                .then(res => {
                    if (res.code == 0) {
                        this.pic.push(res.data)
                    } else {
                        this.$Toast.show('图片上传失败，请稍后再试')
                    }
                })
                .catch(() => {
                    this.$Toast.show('图片上传失败，请稍后再试')
                })
        },
        delImg(item) {
            const curIndex = this.pic.findIndex(v => v.file_md5 == item.file_md5)
            if (curIndex > -1) {
                this.pic.splice(curIndex, 1)
            }
        },
        submit() {
            if (!getCookieToken()) {
                return this.$Login.show()
            }

            if (!this.canSubmit) {
                return false
            }

            if (!this.checked) {
                let msg = '请选择您遇到的问题'
                return this.$Toast.show(msg)
            }
            if (!this.content.trim().length) {
                let msg = '请填写问题描述'
                return this.$Toast.show(msg)
            }
            if (!this.pic.length) {
                return this.$Toast.show('请上传图片')
            }
            if (!this.contact.trim().length) {
                return this.$Toast.show('请输入您的联系方式')
            }

            if (this.request) {
                return false
            }

            this.request = true
            const data = {
                type: 1, // 问题反馈
                question_type: this.checked,
                content: this.content.trim().slice(0, 100),
                pic: JSON.stringify(this.pic.map(v => v.img)),
                contact: this.contact.trim().slice(0, 11),
                order_no: ''
            }

            feedback(data)
                .then(res => {
                    this.request = false
                    if (res.code == 200) {
                        this.$Toast.show('操作成功', 1000, () => {
                            this.isShow = false
                        })
                    } else {
                        this.$Toast.show(res.msg)
                    }
                })
                .catch(() => {
                    this.request = false
                    this.$Toast.show('操作失败，请稍后再试')
                })
        }
    }
}
</script>
<style lang="less" scoped>
.feedback-page {
    .feedback-content {
        padding-top: 40px;
        width: 600px;
        height: 650px;
        background: url(../../../assets/fk-bg.png) center/100% no-repeat;

        .mask-title {
            color: @color-txt-high;
            text-align: center;
            font-size: @font-size-large;
            line-height: 26px;
        }

        .item-wrap {
            width: 430px;
            margin: 38px auto 0;
            margin-top: 38px;

            .item {
                margin-bottom: 32px;

                &.upload-item {
                    margin-bottom: 24px;
                }

                .title {
                    line-height: 21px;
                    color: @color-txt-high;
                    font-size: @font-size-medium;
                    margin-bottom: 13px;

                    &.textarea-title {
                        margin-bottom: 12px;
                    }

                    &.input-title {
                        margin-bottom: 16px;
                    }
                }

                .question-type {
                    .type-wrap {
                        font-size: 0;
                        cursor: pointer;
                        margin-right: 20px;

                        &:last-child {
                            margin-right: 0;
                        }

                        i {
                            vertical-align: middle;
                            font-style: normal;
                            user-select: none;
                        }

                        .i1 {
                            position: relative;
                            cursor: pointer;
                            display: inline-block;
                            margin-right: 8px;
                            width: 16px;
                            height: 16px;
                            background: url(../../../assets/rd.png) center/100% no-repeat;

                            &.checked {
                                background: url(../../../assets/rd_1.png) center/100% no-repeat;
                            }
                        }

                        .i1_checked {
                            position: absolute;
                            cursor: pointer;
                            display: inline-block;
                            margin-left: -24px;
                            margin-top: 8px;
                            width: 16px;
                            height: 15px;
                            background: url(../../../assets/rd_chekd.png) center/100% no-repeat;
                        }

                        .i2 {
                            color: @color-txt-normal;
                            font-size: 14px;
                            line-height: 18px;

                            &.checked {
                                color: @color-txt-high;
                            }
                        }
                    }

                    textarea {
                        color: @color-txt-high;
                        width: 100%;
                        height: 82px;
                        background: transparent;
                        resize: none;
                        outline: none;
                        border: none;
                        padding-bottom: 8px;
                    }

                    input {
                        color: @color-txt-high;
                        padding: 0 16px;
                        width: 430px;
                        height: 44px;
                        border-radius: 10px;
                        resize: none;
                        outline: none;
                        border: none;
                        background-color: #090e0f;
                    }

                    input,
                    textarea {
                        &::-webkit-input-placeholder {
                            color: @color-txt-normal;
                            font-size: 14px;
                        }
                    }
                }

                .upload-wrap {
                    width: 430px;
                    background-color: #090e0f;
                    padding: 14px 14px 16px 16px;
                    border-radius: 10px;

                    .question-type {
                        position: relative;

                        .left-txt {
                            position: absolute;
                            bottom: 0;
                            right: 0;

                            i {
                                font-size: 14px;
                                line-height: 18px;
                                font-style: normal;

                                &.i1 {
                                    color: @color-txt-normal;
                                }

                                &.i2 {
                                    color: @color-txt-normal;
                                }
                            }
                        }
                    }
                }

                .upload-section {
                    font-size: 0;
                    height: 88px;
                    overflow-y: auto;

                    .img-item {
                        position: relative;
                        display: inline-block;
                        width: 80px;
                        height: 80px;
                        border-radius: 2px;
                        margin-right: 8px;
                        border: 2px dashed #333;
                        border-radius: 10px;
                        margin-bottom: 8px;

                        .img {
                            border-radius: 2px;
                            width: 100%;
                            height: 100%;
                            display: block;
                            object-fit: cover;
                        }

                        .icon {
                            cursor: pointer;
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 20px;
                            height: 20px;
                            background: url(../../../assets/ic_x.png) center no-repeat;
                        }
                    }

                    .upload-btn {
                        cursor: pointer;
                        position: relative;
                        user-select: none;
                        background: url(../../../assets/add-plus.png) center no-repeat;
                    }
                }
            }
        }

        .submit-btn {
            user-select: none;
            .button-linear();
            position: absolute;
            width: 240px;
            bottom: 40px;
            height: 40px;
            left: 50%;
            transform: translateX(-50%);
            font-weight: bold;

            &.disabled {
                cursor: not-allowed;
                background: linear-gradient(133deg, rgba(0, 241, 78, 0.8), rgba(2, 203, 138, 0.8));
            }
        }
    }
}
</style>
